const elements = [
  {
    icon: 'ri-sofa-line',
    title: 'The Green Velvet Sofa',
    desc: 'A classic chesterfield in deep forest green — the throne where elegance and instinct collide.',
  },
  {
    icon: 'ri-layout-grid-line',
    title: 'Tiger-Stripe Fur',
    desc: 'Draped across the sofa, the beast enters the luxury space as texture, as memory, as threat.',
  },
  {
    icon: 'ri-focus-3-line',
    title: 'The Lipstick Table',
    desc: 'A single lipstick on marble, bathed in golden light — the object of desire made sacred.',
  },
  {
    icon: 'ri-t-shirt-line',
    title: 'Abandoned Garments',
    desc: 'Clothing scattered on the floor. The aftermath of desire. Control surrendered.',
  },
];

export default function SpaceNarrative() {
  return (
    <section className="bg-[#0A0A0A] py-28 px-6 md:px-16">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="fade-in-up mb-20">
          <p
            className="text-[#4D1815] text-xs mb-4"
            style={{ letterSpacing: '0.5em', fontFamily: "'Cormorant Garamond', serif" }}
          >
            — SPACE CONCEPT —
          </p>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <h2
              className="text-[#EADDCC] font-light leading-tight"
              style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: 'clamp(30px, 4.5vw, 62px)',
                letterSpacing: '0.08em',
              }}
            >
              The Space as
              <br />
              <em className="italic text-[#EADDCC]/60">Narrative</em>
            </h2>
            <p
              className="text-[#EADDCC]/45 text-sm font-light max-w-sm"
              style={{ fontFamily: "'Cormorant Garamond', serif", lineHeight: 1.9, letterSpacing: '0.03em' }}
            >
              The window is not a display.
              It is a confession. Lipstick marks on the wall.
              The beast made visible.
            </p>
          </div>
        </div>

        {/* Full-width campaign visual */}
        <div className="fade-in-up hover-zoom w-full overflow-hidden mb-20" style={{ height: '560px' }}>
          <img
            src="https://static.readdy.ai/image/79bbd12133c9c5c423ad9964f66c8be6/0d673afb92643ad8c69489d38583d5a4.png"
            alt="The Beast Within Window Display"
            className="w-full h-full object-cover object-center"
          />
        </div>

        {/* Elements grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {elements.map((el, i) => (
            <div key={i} className="fade-in-up border-t border-[#EADDCC]/10 pt-8">
              <div className="w-8 h-8 flex items-center justify-center mb-5">
                <i className={`${el.icon} text-[#4D1815] text-xl`} />
              </div>
              <h3
                className="text-[#EADDCC] text-sm font-light mb-3"
                style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.15em' }}
              >
                {el.title}
              </h3>
              <p
                className="text-[#EADDCC]/40 text-xs font-light leading-relaxed"
                style={{ fontFamily: "'Cormorant Garamond', serif", lineHeight: 1.9 }}
              >
                {el.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
